var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgShareToFacebook = function SvgShareToFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 37.5,
    r: 37.5,
    fill: "#0668B1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.34 55V39.046H29v-5.744h4.34v-4.906c0-3.855 2.563-7.396 8.47-7.396 2.392 0 4.16.223 4.16.223l-.14 5.364s-1.803-.017-3.771-.017c-2.13 0-2.471.954-2.471 2.538v4.194H46l-.279 5.744h-6.133V55H33.34Z",
    fill: "#FBFAFA"
  })));
};

export default SvgShareToFacebook;